"use client";
import React from "react";

const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, marginTop: "3px" }}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke="#3399ff"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M6.5 10L9 12.5L13.5 7.5"
      stroke="#3399ff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LEFT_ITEMS: React.ReactNode[] = [
  "The highest tax credential awarded by the IRS. Only 3 parts, 15 months",
  "No Bachelor’s degree or accounting background required",
  "Exams happen from May to February - you decide your exam date!",
];

const RIGHT_ITEMS: React.ReactNode[] = [
  "Once you pass your 1st exam, you have 2 years to pass the remaining 2. Focus on one part at a time",
  "100% objective Multiple Choice Questions (MCQs). No simulations or essays!",
  <>
    Commitment needed: <strong>10-12 hours</strong> of study every week
  </>,
];

const BulletList = ({ items }: { items: React.ReactNode[] }) => (
  <ul className="list-none p-0 m-0 flex flex-col gap-3">
    {items.map((item, i) => (
      <li
        key={i}
        className="flex gap-2.5 text-sm text-[#333] leading-[1.55] [&_strong]:font-bold [&_strong]:text-[#222]"
      >
        <CheckIcon />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const AI_integreated = () => {
  return (
    <section className="bg-white py-8 px-4 max-md:bg-[#f3f3f3] max-md:p-4">
      <div className="main_container py-5 bg-white rounded-2xl">
        <h2 className="text-center text-[24px] font-bold text-[#1D1D1D] mx-auto mb-[30px] leading-[1.3] md:text-[32px] md:block hidden">
          <span className="text-[#39f]">AI-Integrated U.S. EA</span> is Designed
          for
          <br className="md:block hidden" /> Working Professionals
        </h2>

        <h2 className="text-center text-[24px] font-bold text-[#1D1D1D] mx-auto mb-[30px] leading-[1.3] md:text-[32px] md:hidden block">
          <span className="text-[#39f]">AI-Integrated U.S. EA</span> is
          <br /> Designed for Professional
          <br />
          Members
        </h2>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6 items-start max-md:grid-cols-1 max-md:gap-6 md:w-[63%] md:mx-auto">
          <BulletList items={LEFT_ITEMS} />
          <BulletList items={RIGHT_ITEMS} />
        </div>
      </div>
    </section>
  );
};

export default AI_integreated;
